import { render, staticRenderFns } from "./Citation.vue?vue&type=template&id=6da7e73a&scoped=true&"
import script from "./Citation.vue?vue&type=script&lang=js&"
export * from "./Citation.vue?vue&type=script&lang=js&"
import style0 from "./Citation.vue?vue&type=style&index=0&id=6da7e73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7e73a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
